export default "__VITE_ASSET__BChBd08A__"